var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoEntry = function SvgNoEntry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.647 27.582a2.69 2.69 0 0 1 2.693 2.694 2.687 2.687 0 0 1-2.693 2.691 2.67 2.67 0 0 1-2.694-2.69 2.67 2.67 0 0 1 2.694-2.695m-.014-16.246c1.392 0 2.448 1.158 2.34 2.57l-.66 8.936c-.105 1.412-.861 2.57-1.68 2.57-.822 0-1.579-1.158-1.683-2.57l-.664-8.937c-.104-1.411.952-2.57 2.347-2.57Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.852.521H13.425a1.8 1.8 0 0 0-1.273.528L.536 12.665a1.8 1.8 0 0 0-.528 1.274v16.427c0 .477.189.938.528 1.274l11.616 11.616a1.8 1.8 0 0 0 1.273.528h16.427c.478 0 .938-.19 1.274-.528L42.742 31.64c.339-.336.528-.797.528-1.274V13.94c0-.477-.19-.935-.528-1.274L31.126 1.05a1.8 1.8 0 0 0-1.274-.528Zm0 1.802 11.616 11.616v16.427L29.852 41.982H13.425L1.81 30.366V13.94L13.425 2.323z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.347 4.129h-13.44c-.477 0-.937.19-1.273.528L4.13 14.16a1.8 1.8 0 0 0-.528 1.273v13.44c0 .48.189.938.528 1.277l9.504 9.504c.336.336.796.528 1.273.528h13.44c.477 0 .937-.192 1.273-.528l9.504-9.504a1.8 1.8 0 0 0 .528-1.277v-13.44a1.8 1.8 0 0 0-.528-1.273L29.62 4.657a1.8 1.8 0 0 0-1.273-.528m0 1.801 9.504 9.504v13.44l-9.504 9.504h-13.44l-9.504-9.504v-13.44l9.504-9.504z",
    clipRule: "evenodd"
  })));
};
export { SvgNoEntry as ReactComponent };
export default __webpack_public_path__ + "no-entry.c72816da7876fd9cb4f6aafb238281dd.svg";